export default class Forces {
  // STATIC METHODS

  /**
    * 
    * @param {number} m
    * @param {number} g 
    * @param {Phaser.Math.Vector2} vector 
    */
  static constantGravity (m,g, vector) {
    vector.set(0, m * g);
  }

  /**
     * 
     * @param {number} k 
     * @param {Phaser.Math.Vector2} vel 
     * @param {Phaser.Math.Vector2} vector 
     */
  static linearDrag(k, vel, vector) {
    const velMag = vel.length();
    if (velMag > 0) {
      vector.multiply({ x: -k, y: -k });
    }
    else {
      vector.reset();
    }
  }

  /**
     * 
     * @param {Phaser.Math.Vector2[]} arr 
     * @param {Phaser.Math.Vector2} vector 
     */
  static add(arr, vector) {
    vector.reset();
    for (let i = 0; i < arr.length; i++) {
      const force = arr[i];
      vector.add({ x: force.x, y: force.y });
    }
  }

  /**
   * 
   * @param {number} c 
   * @param {Phaser.Math.Vector2} vel 
   * @param {Phaser.Math.Vector2} vector 
   */
  static damping (c,vel, vector) {
    const velMag = vel.length();
    if (velMag > 0) {
      vector.set(vel.x, vel.y);
      vector.multiply({ x: -c, y: -c });
    }
    else {
      vector.reset();
    }
  }

  /**
   * 
   * @param {Phaser.Math.Vector2} base 
   * @param {Phaser.Math.Vector2} v 
   */
  static unit (base, v) {
    const length = base.length();
    if (length > 0) {
      v.set(base.x / length, base.y / length);
    }
    else {
      v.reset();
    }
  }

  static spring (vector, k,displ) {
    vector.set(displ.x * -k, displ.y * -k);
  }
}